/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'../../../lib/@waca/upgrades/UpgradeBase',
	'./utils/WidgetUpgradeUtils'
], (UpgradeBase, WidgetUpgradeUtils) => {

	/**
	* Upgrade VIDA Legend property - Change the Font Size. Currently we have four values for Font size. We will now have only 3 values. This script will check for the current user defined value (if any), and map it to the right value.
	**/

	class VIDADefaultNullValuesUpgrade extends UpgradeBase {

		constructor() {
			super();
			this.VERSION = 2005;
		}

		/**
		 * Perform upgrade
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec){
			if (!WidgetUpgradeUtils.specHasWidgets(spec)) {
				return Promise.resolve(spec);
			}
			for (const widget in spec.widgets){
				const model = spec.widgets[widget];
				if(model && WidgetUpgradeUtils.isLiveWidgetModel(model) && model.properties){
					this._defaultNullUpgrade(model);
				}
			}
			return Promise.resolve(spec);
		}

		// Downgrades are not available in CA
		down(spec) {
			return Promise.resolve(spec);
		}

		/**
		 * If one of the affected properties are defined with a null value, remove the property
		 * to allow default behaviour. Null values could be inadvertently added in 11.1.3->11.1.7 when
		 * trying to restore defaults
		 * 
		 * @param {object} model 
		 */
		_defaultNullUpgrade(model){
			const affectedProperties = [
				'widget.legend.font',
				'widget.legend.color',
				'widget.legend.titleColor',
				'valueLabels.color',
				'valueLabels.font',
				'valueAxis.title.font',
				'valueAxis.title.color',
				'valueAxis.ticks.labels.color',
				'valueAxis.ticks.labels.font',
				'itemAxis.ticks.labels.color',
				'itemAxis.ticks.labels.font'
			];
			model.properties = model.properties.filter(prop => affectedProperties.indexOf(prop.id) == -1 || prop.value !== null);
		}
	}

	return new VIDADefaultNullValuesUpgrade();
});